<div class="ft-detail">

  <div class="ft-toolbar">
    <button mat-button color="primary" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
      I miei moduli
    </button>
  </div>

  <div class="loading-state" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <mat-card *ngIf="!isLoading" class="ft-card">

    <mat-card-content>

      <h2 class="ft-title">{{ templateName }}</h2>

      <div class="ft-empty" *ngIf="files.length === 0 && !error">
        <mat-icon>description</mat-icon>
        <span>Nessun documento disponibile per questo modulo.</span>
      </div>

      <!-- Selettore file (solo se più di uno) -->
      <div class="ft-files" *ngIf="files.length > 1">
        <button
          mat-stroked-button
          *ngFor="let f of files"
          [color]="f === selectedFile ? 'primary' : undefined"
          (click)="selectFile(f)">
          <mat-icon>picture_as_pdf</mat-icon>
          {{ f.FileName || 'Documento' }}
        </button>
      </div>

      <!-- PDF embedded (sola visualizzazione) -->
      <div class="ft-viewer" *ngIf="selectedFile">

        <div class="ft-viewer-head">
          <mat-icon>picture_as_pdf</mat-icon>
          <span class="ft-viewer-name">{{ selectedFile.FileName || 'Documento' }}</span>
          <!-- Nel profilo il documento è sempre in sola visualizzazione (mai scaricabile). -->
          <span class="ft-viewonly">Solo visualizzazione</span>
        </div>

        <div class="pdf-loading" *ngIf="pdfLoading">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <iframe
          *ngIf="pdfUrl && !pdfLoading"
          [src]="pdfUrl"
          title="Anteprima documento"
          class="ft-iframe"></iframe>

      </div>

      <!-- Form dinamico generato dal template (sotto il PDF) -->
      <div class="ft-form" *ngIf="formConfiguration">
        <ct-dynamic-form-generator #formGenerator [configuration]="formConfiguration"></ct-dynamic-form-generator>
      </div>

      <!-- Modulo senza form (JSON vuoto): solo presa visione del documento -->
      <div class="ft-ack" *ngIf="acknowledgeOnly">
        <button
          mat-raised-button
          color="primary"
          (click)="presaVisione()"
          [disabled]="acknowledged">
          {{ acknowledged ? 'Presa visione registrata' : 'Presa visione' }}
        </button>
      </div>

      <div class="ft-error" *ngIf="error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error }}</span>
      </div>

    </mat-card-content>

  </mat-card>

  <!-- Modale di conferma presa visione -->
  <ng-template #confirmPresaVisioneDialog>
    <h2 mat-dialog-title>Conferma presa visione</h2>
    <mat-dialog-content>
      Confermi di aver preso visione del documento<span *ngIf="templateName"> "{{ templateName }}"</span>?
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Annulla</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true">Conferma</button>
    </mat-dialog-actions>
  </ng-template>

</div>
